import {
  createBrowserRouter,
  Outlet,
  ScrollRestoration,
} from "react-router-dom";

import {
  LandingPage,
  TentangPage,
  PenghargaanPage,
  ArtikelPage,
  BeasiswaPage,
  ErrorPage,
  FasilitasPage,
  FaqPage,
  InformasiAkomodasiPage,
  KegiatanAcaraPage,
  TenagaPengajarPage,
  LowonganKerjaPage,
  ProgramPage,
  SambutanPage,
  BiayaPendidikanPage,
  KontakPage,
  RedirectingPage,
  ArtikelTextPage,
  SejarahPage,
  KegiatanAcaraDetailPage,
  StrukturUniversitasPage,
  PenghargaanDetailPage,
  BeasiswaDetailPage,
  LowonganKerjaDetail,
} from "../pages";

const RootWrapper = () => {
  return (
    <>
      <ScrollRestoration />
      {/* If using Lenis smooth scroll, use <ScrollToTop /> instead of <ScrollRestoration /> */}

      <Outlet />
    </>
  );
};

export const router = createBrowserRouter([
  {
    element: <RootWrapper />,
    children: [
      { path: "/", element: <LandingPage /> },
      { path: "/tentang", element: <TentangPage /> },
      { path: "/penghargaan", element: <PenghargaanPage /> },
      { path: "/penghargaan/:slug", element: <PenghargaanDetailPage /> },
      { path: "/artikel", element: <ArtikelPage /> },
      { path: "/artikel/:slug", element: <ArtikelTextPage /> },
      { path: "/beasiswa", element: <BeasiswaPage /> },
      { path: "/beasiswa/:slug", element: <BeasiswaDetailPage /> },
      { path: "/fasilitas", element: <FasilitasPage /> },
      { path: "/faq", element: <FaqPage /> },
      { path: "/informasi-akomodasi", element: <InformasiAkomodasiPage /> },
      { path: "/kegiatan-acara", element: <KegiatanAcaraPage /> },
      { path: "/kegiatan-acara/:slug", element: <KegiatanAcaraDetailPage /> },
      { path: "/tenaga-pengajar", element: <TenagaPengajarPage /> },
      { path: "/struktur-universitas", element: <StrukturUniversitasPage /> },
      { path: "/lowongan-kerja", element: <LowonganKerjaPage /> },
      { path: "/lowongan-kerja/:slug", element: <LowonganKerjaDetail /> },
      { path: "/redirect", element: <RedirectingPage /> },
      { path: "/program/:id", element: <ProgramPage /> },
      { path: "/sambutan", element: <SambutanPage /> },
      { path: "/biaya-pendidikan", element: <BiayaPendidikanPage /> },
      { path: "/kontak", element: <KontakPage /> },
      { path: "*", element: <ErrorPage /> },
      { path: "/sejarah", element: <SejarahPage /> },
    ],
  },
]);
